export default function Achievements() {
  const achievements = [
    {
      icon: 'ri-time-line',
      name: 'Часов в игре',
      value: '1,247',
      description: 'Вы провели в Roblox больше времени, чем 87% игроков',
      gradient: 'from-[#00d4ff]/10 to-[#00d4ff]/5',
      iconBg: 'from-[#00d4ff] to-[#0099cc]',
    },
    {
      icon: 'ri-medal-line',
      name: 'Получено бейджей',
      value: '156',
      description: 'Невероятная коллекция достижений за год',
      gradient: 'from-[#a855f7]/10 to-[#a855f7]/5',
      iconBg: 'from-[#a855f7] to-[#7c3aed]',
    },
    {
      icon: 'ri-trophy-line',
      name: 'Пройдено ивентов',
      value: '42',
      description: 'Вы участвовали во всех главных событиях года',
      gradient: 'from-[#ffd700]/10 to-[#ffd700]/5',
      iconBg: 'from-[#ffd700] to-[#ffed4e]',
    },
    {
      icon: 'ri-vip-crown-line',
      name: 'Редких предметов',
      value: '89',
      description: 'Уникальная коллекция эксклюзивных вещей',
      gradient: 'from-[#00d4ff]/10 to-[#a855f7]/5',
      iconBg: 'from-[#00d4ff] to-[#a855f7]',
    },
  ];

  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 lg:py-32">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 sm:gap-12">
        {/* Left Column - Title */}
        <div className="lg:col-span-2 lg:sticky lg:top-32 self-start">
          <div className="relative">
            <div className="hidden sm:block absolute -left-4 top-0 text-[120px] sm:text-[150px] lg:text-[180px] font-black text-white/5 leading-none select-none">
              2025
            </div>
            <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white relative z-10 px-2">
              Ваши<br />рекорды
            </h2>
          </div>
        </div>

        {/* Right Column - Metrics */}
        <div className="lg:col-span-3 space-y-4 sm:space-y-6">
          {achievements.map((achievement, index) => (
            <div
              key={index}
              className={`bg-gradient-to-r ${achievement.gradient} rounded-2xl sm:rounded-3xl p-5 sm:p-6 lg:p-8 border-l-4 border-[#00d4ff] hover:scale-[1.02] transition-transform duration-300`}
            >
              <div className="flex items-start gap-4 sm:gap-6">
                {/* Icon */}
                <div className={`w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center rounded-xl sm:rounded-2xl bg-gradient-to-br ${achievement.iconBg} flex-shrink-0`}>
                  <i className={`${achievement.icon} text-2xl sm:text-3xl text-white w-6 sm:w-8 h-6 sm:h-8 flex items-center justify-center`}></i>
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-white mb-2">
                    {achievement.name}
                  </h3>
                  <p className="text-4xl sm:text-5xl lg:text-6xl font-black bg-gradient-to-r from-[#00d4ff] to-[#a855f7] bg-clip-text text-transparent mb-2 sm:mb-3">
                    {achievement.value}
                  </p>
                  <p className="text-xs sm:text-sm text-white/50 leading-relaxed">
                    {achievement.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
